import { useEffect } from 'react';
import apiService from '../services/ApiService';
import { installNativeBridgeHost, isRunningInBiltNativeShell, syncNativeSession } from '../utils/nativeShell';

/** Mirror web login/refresh tokens into native Secure Store for scan + API parity. */
export function useNativeSessionSync() {
  useEffect(() => {
    if (!isRunningInBiltNativeShell()) return undefined;

    const syncIfAuthenticated = () => {
      if (!apiService.isAuthenticated()) return;
      const tokens = apiService.getStoredAuthTokens();
      if (!tokens?.accessToken || !tokens.user) return;
      syncNativeSession({
        accessToken: tokens.accessToken,
        refreshToken: tokens.refreshToken,
        expiresAt: tokens.expiresAt,
        user: tokens.user,
      });
    };

    syncIfAuthenticated();

    const onShellReady = () => syncIfAuthenticated();
    window.addEventListener('bilt-native-shell-ready', onShellReady);

    const cleanupBridge = installNativeBridgeHost((event) => {
      if (event.type === 'SHELL_READY') {
        syncIfAuthenticated();
      }
    });

    return () => {
      window.removeEventListener('bilt-native-shell-ready', onShellReady);
      cleanupBridge();
    };
  }, []);
}
